if( !customElements.get('product-anchor-nav') ){
  customElements.define(
    'product-anchor-nav',
    class ProductAnchorNav extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.init();
      }

      init() {
        this.sectionIdPrefix = this.dataset.sectionIdPrefix || '';

        this.buttons = this.querySelectorAll('.anchor-btn');
        this.buttons.forEach((item) => {
          const classNames = item.getAttribute('data-anchor-link').split(',');
          item.addEventListener('click', this.onAnchorBtnClick(classNames));
        });

        // 监控target是否滚动到位置 用onscroll 
        window.addEventListener('scroll', this.onScroll);

        // 监听sticky元素的状态变化，控制container的位置
        this.initStickyObserver();
      }

      initStickyObserver() {
        // 获取sticky元素和container
        this.stickyElement = this.closest('.sticky-element');
        this.container = this.closest('.product-anchor-nav-container');

        if (!this.stickyElement || !this.container) {
          return;
        }

        // 创建一个参考元素来检测sticky状态
        const referenceElement = document.createElement('div');
        referenceElement.innerText = 'sticky-reference';
        referenceElement.style.cssText = `
          width: 1px;
          height: 1px;
          opacity: 0;
          pointer-events: none;
        `;
        this.stickyElement.parentNode.insertBefore(referenceElement, this.stickyElement);

        // 使用IntersectionObserver来检测sticky状态
        this.stickyObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.target === referenceElement) {
                if (entry.isIntersecting) {
                  // 元素在视口中，不处于sticky状态
                  this.container.classList.remove('expanded');
                } else {
                  // 元素不可见，需要判断是在视口上方还是下方
                  // 只有当元素在视口上方时才添加expanded类
                  const elementRect = entry.target.getBoundingClientRect();
                  if (elementRect.bottom < 0) {
                    // 元素在视口上方，开始sticky
                    this.container.classList.add('expanded');
                  } else {
                    // 元素在视口下方，不添加expanded类
                    this.container.classList.remove('expanded');
                  }
                }
              }
            });
          },
          {
            root: null,
            rootMargin: '0px',
            threshold: 1.0
          }
        );

        // 开始观察参考元素
        this.stickyObserver.observe(referenceElement);
      }

      // 当组件卸载 断开所有observer
      disconnectedCallback() {
        if (this.stickyObserver) {
          this.stickyObserver.disconnect();
        }
        window.removeEventListener('scroll', this.onScroll);
      }

      onScroll = () => {
        if (this.isAnimate){
          return;
        }
        const topOffset = this.getTopOffset();
        const windowHeight = window.innerHeight;
        const windowMiddle = window.scrollY + windowHeight / 2;
        
        // 存储所有可见元素及其位置信息
        const visibleItems = [];
        
        // 先计算所有元素的位置和与视口的匹配程度
        this.buttons.forEach((item) => {
          const classNames = item.getAttribute('data-anchor-link').split(',');
          if(!classNames || classNames.length === 0){
            return;
          }

          // 获取的是targets的第一个元素的top 和最后一个元素的bottom
          const targetElements = document.querySelectorAll("." + classNames[0]);
          if(targetElements.length === 0){
            return;
          }
          const firstTargetElement = targetElements[0];
          const lastElements = document.querySelectorAll("." + classNames[classNames.length - 1]);
          const lastTargetElement = lastElements[lastElements.length - 1];
          if (!firstTargetElement || !lastTargetElement) {
            return;
          }
          
          const targetTop = firstTargetElement.offsetTop - topOffset;
          const targetHeight = lastTargetElement.offsetTop + lastTargetElement.offsetHeight - targetTop;
          const targetBottom = targetTop + targetHeight;
          const targetCenter = targetTop + targetHeight / 2;
          
          // 计算元素与视口中间位置的距离
          const distanceToMiddle = Math.abs(windowMiddle - targetCenter);
          
          // 如果元素部分或完全在视口中，将其添加到可见列表
          if (windowMiddle >= targetTop && windowMiddle <= targetBottom) {
            visibleItems.push({
              button: item,
              distance: distanceToMiddle,
              targetTop: targetTop
            });
          }
        });
        
        // 首先移除所有按钮的active状态
        this.buttons.forEach((item) => {
          item.removeAttribute('data-active');
        });
        
        // 如果有可见元素，找到最合适的一个激活
        if (visibleItems.length > 0) {
          // 排序：首先按距离视口中间的远近排序，距离近的优先
          // 如果距离相同，则按位置排序，位置靠上的优先
          visibleItems.sort((a, b) => {
            if (a.distance !== b.distance) {
              return a.distance - b.distance;
            }
            return a.targetTop - b.targetTop;
          });
          
          // 只激活最匹配的一个按钮
          visibleItems[0].button.setAttribute('data-active', 'true');
          
          // 滚动使激活的按钮在容器内可见
          this.scrollButtonIntoView(visibleItems[0].button);
        }
      }



      getTopOffset() {
        const stickyOffset = getComputedStyle(this).getPropertyValue('--sticky-offset').trim();
        const newHeaderHeight = getComputedStyle(this).getPropertyValue('--header-height').trim();
        const newHeaderNavigationHeight = getComputedStyle(this).getPropertyValue('--header-navigation-height').trim();

        const topOffset = parseFloat(newHeaderHeight) - parseFloat(newHeaderNavigationHeight) - parseFloat(stickyOffset) - 0.1 + this.offsetHeight;
        return topOffset;
      }

      onAnchorBtnClick = (classNames) => {
        return (e) => {
          e.preventDefault();
           
          // 激活当前button
          this.buttons.forEach((item) => {
            item.removeAttribute('data-active');
          });
          const activeButton = e.target.closest('.anchor-btn');
          activeButton.setAttribute('data-active', 'true');
          
          // 滚动使激活的按钮在容器内可见
          this.scrollButtonIntoView(activeButton);

          // 如果是tab，需要激活对应的tab
          const tabIndex = activeButton.getAttribute('data-tab');
          console.log("tabIndex", tabIndex);
          

          const targetElements = document.querySelectorAll("." + classNames[0]);
          if (!targetElements || targetElements.length === 0) {
            return;
          }
          const targetElement = targetElements[0];
          if (targetElement) {

            if (tabIndex || tabIndex === 0) {
              console.log("tabIndex", tabIndex, tabIndex === 0 , targetElement);
              const tabsComponent = targetElement.querySelector("tabs-component");
              if(tabsComponent){
                tabsComponent.setActiveTab(tabIndex);
              }
            }



            // 设置滚动动画标志
            this.isAnimate = true;
            
            // 清理之前可能存在的监听器和定时器，避免多个滚动动画同时进行
            if (this.scrollEndTimeout) {
              clearTimeout(this.scrollEndTimeout);
            }
            if (this.scrollEndHandler) {
              window.removeEventListener('scroll', this.scrollEndHandler);
            }
            
            // 滚动到目标位置
            window.scrollTo({
              top: targetElement.offsetTop - this.getTopOffset(),
              behavior: 'smooth'
            });
            
            // 创建滚动结束检测函数并保存引用
            this.scrollEndHandler = () => {
              // 检查滚动是否基本停止（通过比较连续两次滚动位置）
              if (this.lastScrollY === window.scrollY) {
                this.isAnimate = false;
                window.removeEventListener('scroll', this.scrollEndHandler);
                this.scrollEndHandler = null;
              }
              this.lastScrollY = window.scrollY;
            };
            
            // 添加滚动事件监听器
            window.addEventListener('scroll', this.scrollEndHandler);
            
            // 设置超时清理，确保即使滚动事件未触发也能重置状态
            this.scrollEndTimeout = setTimeout(() => {
              this.isAnimate = false;
              if (this.scrollEndHandler) {
                window.removeEventListener('scroll', this.scrollEndHandler);
                this.scrollEndHandler = null;
              }
            }, 1000);
          }
        }
      }
      
      // 将激活的按钮滚动到其容器的可见区域
      scrollButtonIntoView(button) {
        const container = button.closest('.anchor-nav__content');
        const item = button.parentElement;
        if (container) {
          // 计算按钮相对于容器的位置
          const buttonLeft = item.offsetLeft;
          const buttonWidth = item.offsetWidth;
          const containerScrollLeft = container.scrollLeft;
          const containerWidth = container.clientWidth;
          
          // 判断按钮是否已经在可见区域内
          // 如果按钮左侧超出容器左侧，或者右侧超出容器右侧，则需要滚动
          if (buttonLeft < containerScrollLeft || 
              buttonLeft + buttonWidth > containerScrollLeft + containerWidth) {
            
            // 计算滚动位置，使按钮居中或适当调整
            // 这里使用按钮左侧位置减去容器宽度的四分之一，使按钮更靠左显示
            const targetScrollLeft = buttonLeft - containerWidth / 4;
            
            // 平滑滚动到目标位置
            container.scrollTo({
              left: Math.max(0, targetScrollLeft),
              behavior: 'smooth'
            });
          }
        }
      }

    }
  )



}